module.exports = __webpack_public_path__ + "img/right-logo@2x.d3549f4a.png";